export default "__VITE_ASSET__Be$DWQza__"